import { render, staticRenderFns } from "./horizontalHead.vue?vue&type=template&id=13843850&scoped=true"
import script from "./horizontalHead.vue?vue&type=script&lang=js"
export * from "./horizontalHead.vue?vue&type=script&lang=js"
import style0 from "./horizontalHead.vue?vue&type=style&index=0&id=13843850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13843850",
  null
  
)

export default component.exports